import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router';

import Url from '../lib/url';

const OrderTypeButton = (props) => {
  const data = props.type === 'delivery' ?
    { to: Url.orderDelivery, icon: 'bi_building-house' } :
    { to: Url.orderTakeAway, icon: 'bi_kitchen-hood-a' };
  return (
    <Link className="orderType__button" to={data.to(props.appId)}>
      <span>
        <i className={data.icon} />
        <span className="orderType__buttonLabel">{props.children}</span>
      </span>
    </Link>
  );
};

OrderTypeButton.propTypes = {
  appId: PropTypes.string,
  type: PropTypes.oneOf(['delivery', 'takeAway']),
  children: PropTypes.string,
};


export default OrderTypeButton;



// WEBPACK FOOTER //
// ./src/components/order-type-button.js